var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c(
        "div",
        { staticClass: "col-12 col-lg-4 order-lg-2" },
        [
          _c("account-sidebar", {
            attrs: {
              lng: _vm.lng,
              mainlng: _vm.mainlng,
              translations: _vm.translations,
              accountlink: _vm.accountlink,
              logoutlink: _vm.logoutlink,
              isaccountroute: !!_vm.isaccountroute,
              account: _vm.localAccount,
            },
            on: {
              AvattarChanged: function ($event) {
                return _vm.changeAvatar($event)
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-12 col-lg-8 order-lg-1" },
        [
          _vm._l(_vm.preparedNotifications, function (notification, key) {
            return _c("notification-alert-block", {
              key: key,
              attrs: {
                notification: notification,
                setnotificationlink: _vm.setnotificationlink,
              },
            })
          }),
          _vm._v(" "),
          _c("div", { staticClass: "simple__block" }, [
            _c("h3", { staticClass: "h5" }, [
              _vm._v(
                _vm._s(
                  _vm.get_translation_constant("text_arrived_package_list")
                )
              ),
            ]),
            _vm._v(" "),
            _c("table", { staticClass: "table table__arrived__orders" }, [
              _c("thead", [
                _c("tr", [
                  _c("th", [
                    _c("div", { staticClass: "checkbox__custom" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.toggleSelect,
                            expression: "toggleSelect",
                          },
                        ],
                        attrs: {
                          id: "select_all",
                          name: "select_all",
                          type: "checkbox",
                        },
                        domProps: {
                          checked: Array.isArray(_vm.toggleSelect)
                            ? _vm._i(_vm.toggleSelect, null) > -1
                            : _vm.toggleSelect,
                        },
                        on: {
                          change: [
                            function ($event) {
                              var $$a = _vm.toggleSelect,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.toggleSelect = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.toggleSelect = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.toggleSelect = $$c
                              }
                            },
                            function ($event) {
                              return _vm.toggleAllSelect()
                            },
                          ],
                        },
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "select_all" } }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("th", [
                    _vm._v(
                      _vm._s(
                        _vm.get_translation_constant("text_tracking_number")
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("th", [
                    _vm._v(
                      _vm._s(_vm.get_translation_constant("text_delivery"))
                    ),
                  ]),
                  _vm._v(" "),
                  _c("th", [
                    _vm._v(_vm._s(_vm.get_translation_constant("text_price"))),
                  ]),
                  _vm._v(" "),
                  _vm.account.location_id !== 1
                    ? _c("th", [
                        _vm._v(
                          _vm._s(_vm.get_translation_constant("text_flight"))
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("th", [
                    _vm._v(_vm._s(_vm.get_translation_constant("text_status"))),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(this.orders, function (order, key) {
                  return _c("tr", [
                    _c("td", [
                      _c("div", { staticClass: "checkbox__custom" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: order.checked,
                              expression: "order.checked",
                            },
                          ],
                          staticClass: "order__payment_check",
                          attrs: {
                            id: "select" + order.id,
                            name: "select" + order.id,
                            type: "checkbox",
                          },
                          domProps: {
                            checked: Array.isArray(order.checked)
                              ? _vm._i(order.checked, null) > -1
                              : order.checked,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = order.checked,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      order,
                                      "checked",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      order,
                                      "checked",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(order, "checked", $$c)
                              }
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "select" + order.id } }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("a", { attrs: { href: order.view_link } }, [
                        _vm._v(_vm._s(order.track_code)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "div",
                        {
                          staticClass:
                            "table__extras d-flex justify-content-sm-end justify-content-lg-start align-items-center",
                        },
                        [
                          _vm._l(order.services, function (service, key) {
                            return _c(
                              "span",
                              {
                                staticClass:
                                  "tooltip__block tooltip__top tooltip__block_simple",
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "tooltip__block_trigger" },
                                  [
                                    _c("img", {
                                      staticClass: "service-image",
                                      class: _vm.checkServiceHasUploads(
                                        service,
                                        order
                                      ),
                                      attrs: { src: service.icon, alt: "" },
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "tooltip__block_inner" },
                                  [_c("p", [_vm._v(_vm._s(service.title))])]
                                ),
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _vm._l(order.solutions, function (solution, key) {
                            return _c(
                              "span",
                              {
                                staticClass:
                                  "tooltip__block tooltip__top tooltip__block_simple",
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "tooltip__block_trigger" },
                                  [
                                    _c("img", {
                                      staticClass: "service-image",
                                      attrs: { src: solution.icon, alt: "" },
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "tooltip__block_inner" },
                                  [_c("p", [_vm._v(_vm._s(solution.title))])]
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            typeof order.total_price !== "undefined" &&
                              order.total_price !== null &&
                              order.total_price > 0
                              ? order.total_price + " $"
                              : "-"
                          )
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.account.location_id !== 1
                      ? _c("td", [_vm._v(_vm._s(_vm.getOrderFlight(order)))])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "strong",
                        {
                          class: !!order.paid ? "color__green" : "color__red",
                          style:
                            _vm.account.location_id !== 1
                              ? ""
                              : "cursor: pointer;",
                          on: {
                            click: function ($event) {
                              return _vm.viewOrder(order)
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              !!order.paid
                                ? _vm.get_translation_constant(
                                    "arrived_order_paid_status_name"
                                  )
                                : _vm.get_translation_constant(
                                    "arrived_order_not_paid_status_name"
                                  )
                            )
                          ),
                        ]
                      ),
                    ]),
                  ])
                }),
                0
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "orderPayment_block",
                style: _vm.someOrderIsNotPaid
                  ? ""
                  : "display: none !important;",
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-md-flex justify-content-between align-items-center",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "text__small color__red mb-3 mb-md-0" },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.get_translation_constant("text_pay_for_order")
                            ) +
                            "\n                    "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "d-md-flex align-items-center" }, [
                      _c(
                        "strong",
                        { staticClass: "mr-5 d-block mb-3 mb-md-0" },
                        [
                          _vm._v(
                            _vm._s(_vm.get_translation_constant("text_pay")) +
                              ":\n                            " +
                              _vm._s(_vm.calculatedOrdersTotalSum)
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "btn btn__large btn__blue d-block",
                          attrs: {
                            href: "#",
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#orderPayment",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.get_translation_constant("text_pay"))
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "orderDelivery_block",
                style: _vm.someOrderIsPaid ? "" : "display: none !important;",
              },
              [
                _c(
                  "div",
                  { staticClass: "d-md-flex justify-content-end mt-4" },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "btn btn__large btn__green d-block",
                        attrs: {
                          href: "#",
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#orderDelivery",
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.get_translation_constant(
                              "text_arrange_delivery"
                            )
                          )
                        ),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ]),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal fade modal__custom",
          attrs: {
            id: "orderPayment",
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "orderPaymentTitle",
            "aria-hidden": "true",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-dialog-centered",
              attrs: { role: "document" },
            },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c(
                    "h5",
                    {
                      staticClass: "modal-title",
                      attrs: { id: "orderPaymentTitle" },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.get_translation_constant("text_order_payment")
                        )
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("button", {
                    staticClass: "close",
                    attrs: {
                      type: "button",
                      "data-bs-dismiss": "modal",
                      "aria-label": "Close",
                      id: "orderPaymentClose",
                      "data-bs-target": "#orderPayment",
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("table", { staticClass: "table table__order_payment" }, [
                    _c("thead", [
                      _c("tr", [
                        _c("th", [
                          _c("p", [
                            _c("span", { staticClass: "h_text" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.get_translation_constant("text_bill")
                                )
                              ),
                            ]),
                            _vm._v(
                              "\n                                    " +
                                _vm._s(
                                  _vm.orders.filter(function (order) {
                                    return (
                                      !!order.paid === false && !!order.checked
                                    )
                                  }).length
                                ) +
                                "\n                                    (" +
                                _vm._s(
                                  _vm.get_translation_constant("text_one_order")
                                ) +
                                ")"
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("th"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(
                        _vm.checkedNotPaidOrders,
                        function (form_order, key) {
                          return _c("tr", [
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm.get_translation_constant(
                                    "text_order_number"
                                  )
                                ) + _vm._s(form_order.id)
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  form_order.total_price !== null &&
                                    typeof form_order.total_price.toFixed(2) !==
                                      "undefined"
                                    ? form_order.total_price.toFixed(2)
                                    : ""
                                ) + " $\n                            "
                              ),
                            ]),
                          ])
                        }
                      ),
                      0
                    ),
                    _vm._v(" "),
                    _c("tfoot", [
                      _c("tr", [
                        _c("td", { staticClass: "h6 color__black" }, [
                          _vm._v(
                            _vm._s(_vm.get_translation_constant("text_total"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(_vm.calculatedOrdersTotalSum)),
                        ]),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "form__col form__col_promo_code",
                      class: _vm.hasError("promo_code"),
                    },
                    [
                      _c("label", { attrs: { for: "promo_code" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.get_translation_constant("text_promo_code")
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.promo_code.code,
                            expression: "promo_code.code",
                          },
                        ],
                        staticClass: "form__control",
                        attrs: {
                          name: "promo_code",
                          id: "promo_code",
                          placeholder: _vm.get_translation_constant(
                            "text_promo_code_placeholder"
                          ),
                        },
                        domProps: { value: _vm.promo_code.code },
                        on: {
                          input: [
                            function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.promo_code,
                                "code",
                                $event.target.value
                              )
                            },
                            function ($event) {
                              return _vm.clearError("promo_code")
                            },
                          ],
                        },
                      }),
                      _vm._v(" "),
                      _vm.isValidPromo
                        ? _c("div", {
                            staticClass: "form__success",
                            domProps: {
                              innerHTML: _vm._s(_vm.getPromoCodeText),
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasErrorMessage("promo_code")
                        ? _c("div", { staticClass: "form__error" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.hasErrorMessage("promo_code")) +
                                "\n                        "
                            ),
                          ])
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _c("form", { attrs: { action: "" } }, [
                    _c("div", { staticClass: "row align-items-start" }, [
                      _c("div", { staticClass: "col-12 col-md-8" }, [
                        _c(
                          "div",
                          {
                            staticClass: "form__col",
                            class: _vm.hasError("paymentMethod"),
                          },
                          [
                            _c(
                              "multiselect",
                              {
                                staticClass: "form-control",
                                attrs: {
                                  multiple: false,
                                  placeholder:
                                    _vm.get_translation_constant(
                                      "text_choose_method"
                                    ),
                                  options: _vm.filteredPaymentMethods,
                                  label: "title",
                                  selectLabel: "",
                                  deselectLabel: "",
                                  optionHeight: 48,
                                  showPointer: true,
                                },
                                model: {
                                  value: _vm.form.paymentMethod,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "paymentMethod", $$v)
                                  },
                                  expression: "form.paymentMethod",
                                },
                              },
                              [void 0],
                              2
                            ),
                            _vm._v(" "),
                            _vm.hasErrorMessage("paymentMethod")
                              ? _c(
                                  "div",
                                  { staticClass: "form__error" },
                                  [
                                    _vm.form.paymentMethod === null
                                      ? [
                                          _vm._v(
                                            "\n                                            " +
                                              _vm._s(
                                                _vm.get_translation_constant(
                                                  "text_insufficient_funds"
                                                )
                                              ) +
                                              "\n                                        "
                                          ),
                                        ]
                                      : _vm.checkFunds
                                      ? [
                                          _vm._v(
                                            "\n                                            " +
                                              _vm._s(
                                                _vm.get_translation_constant(
                                                  "text_insufficient_funds"
                                                )
                                              ) +
                                              "\n                                        "
                                          ),
                                        ]
                                      : [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.get_translation_constant(
                                                  "text_field_is_required"
                                                )
                                              ) +
                                              "\n                                        "
                                          ),
                                        ],
                                  ],
                                  2
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-12 col-md-4" }, [
                        _c("div", { staticClass: "form__col" }, [
                          _c("input", {
                            staticClass:
                              "btn btn__large btn__blue btn__block payment__success",
                            attrs: { type: "submit" },
                            domProps: {
                              value: _vm.get_translation_constant("text_pay"),
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.pay()
                              },
                            },
                          }),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal fade modal__custom",
          attrs: {
            id: "orderDelivery",
            tabindex: "-1",
            "data-bs-backdrop": "static",
            role: "dialog",
            "aria-labelledby": "orderDeliveryTitle",
            "aria-hidden": "true",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-dialog-centered",
              attrs: { role: "document" },
            },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c(
                    "h5",
                    {
                      staticClass: "modal-title",
                      attrs: { id: "orderDeliveryTitle" },
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.get_translation_constant(
                              "text_arrange_delivery"
                            )
                          )
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("button", {
                    staticClass: "close",
                    attrs: {
                      type: "button",
                      "data-bs-dismiss": "modal",
                      "aria-label": "Close",
                      id: "orderDeliveryClose",
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.handleCloseShipping()
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("table", { staticClass: "table table__order_payment" }, [
                    _c("thead", [
                      _c("tr", [
                        _c("th", [
                          _c("p", [
                            _c("span", { staticClass: "h_text" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.get_translation_constant("text_bill")
                                )
                              ),
                            ]),
                            _vm._v(
                              "\n                                    " +
                                _vm._s(
                                  _vm.orders.filter(function (order) {
                                    return (
                                      !!order.paid &&
                                      !!order.checked &&
                                      order.shipping_info === null
                                    )
                                  }).length
                                ) +
                                "\n                                    (" +
                                _vm._s(
                                  _vm.get_translation_constant("text_one_order")
                                ) +
                                ")"
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("th"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(
                        _vm.checkedPaidNotShippedOrders,
                        function (form_order, key) {
                          return _c("tr", [
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm.get_translation_constant(
                                    "text_order_number"
                                  )
                                ) + _vm._s(form_order.id)
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(form_order.total_price.toFixed(2)) + " $"
                              ),
                            ]),
                          ])
                        }
                      ),
                      0
                    ),
                    _vm._v(" "),
                    _vm._m(0),
                  ]),
                  _vm._v(" "),
                  _c(
                    "form",
                    { attrs: { action: "" } },
                    [
                      _c("h5", { staticClass: "h_text" }, [
                        _vm._v(
                          _vm._s(
                            _vm.get_translation_constant(
                              "text_choose_delivery_method"
                            )
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form__col d-none d-md-block" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "row no-gutters radio_group__custom",
                            },
                            _vm._l(_vm.deliverymethods, function (method, key) {
                              return _c(
                                "div",
                                {
                                  staticClass:
                                    "col-12 col-md-4 radio_group__item",
                                },
                                [
                                  _c("input", {
                                    attrs: { id: method.title, type: "radio" },
                                    domProps: {
                                      checked:
                                        method.id ===
                                        _vm.form.deliveryMethod.id,
                                      value: method.id,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.setDelivery(method)
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    { attrs: { for: method.title } },
                                    [_vm._v(_vm._s(method.title))]
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form__col d-md-none delivery__select" },
                        [
                          _c("multiselect", {
                            staticClass: "form-control",
                            attrs: {
                              multiple: false,
                              placeholder: _vm.get_translation_constant(
                                "text_choose_delivery_method"
                              ),
                              options: _vm.deliveryMethodsWithDefault,
                              label: "title",
                              selectLabel: "",
                              deselectLabel: "",
                              optionHeight: 48,
                              showPointer: true,
                            },
                            model: {
                              value: _vm.form.deliveryMethod,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "deliveryMethod", $$v)
                              },
                              expression: "form.deliveryMethod",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.deliverymethods, function (method, key) {
                        return [
                          _vm.account.location_id === 1
                            ? [
                                method.shipping_type_id === 1
                                  ? void 0
                                  : method.shipping_type_id === 2
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.form.deliveryMethod.id !==
                                                  "undefined" &&
                                                method.id ===
                                                  _vm.form.deliveryMethod.id,
                                              expression:
                                                "(form.deliveryMethod.id !=='undefined') && (method.id === form.deliveryMethod.id)",
                                            },
                                          ],
                                          staticClass:
                                            "delivery__address_block",
                                        },
                                        [
                                          _c("div", { staticClass: "row" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "col-12 col-lg-6",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "form__col",
                                                    class: _vm.hasError(
                                                      "deliveryMethod.city",
                                                      true
                                                    ),
                                                  },
                                                  [
                                                    _c("label", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.get_translation_constant(
                                                            "text_city"
                                                          )
                                                        )
                                                      ),
                                                      _c("sup", [_vm._v("*")]),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("multiselect", {
                                                      staticClass:
                                                        "form-control",
                                                      attrs: {
                                                        multiple: false,
                                                        placeholder:
                                                          _vm.get_translation_constant(
                                                            "text_choose_city"
                                                          ),
                                                        options: method.cities,
                                                        label: "title",
                                                        selectLabel: "",
                                                        deselectLabel: "",
                                                        optionHeight: 48,
                                                        showPointer: true,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form
                                                            .deliveryMethod
                                                            .city,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form
                                                              .deliveryMethod,
                                                            "city",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.deliveryMethod.city",
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _vm.hasErrorMessage(
                                                      "deliveryMethod.city",
                                                      true
                                                    )
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "form__error",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                        " +
                                                                _vm._s(
                                                                  _vm.get_translation_constant(
                                                                    "text_field_is_required"
                                                                  )
                                                                ) +
                                                                "\n                                                    "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "col-12 col-lg-6",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "form__col",
                                                    class: _vm.hasError(
                                                      "deliveryMethod.address"
                                                    ),
                                                  },
                                                  [
                                                    _c("label", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.get_translation_constant(
                                                            "text_delivery_address"
                                                          )
                                                        )
                                                      ),
                                                      _c("sup", [_vm._v("*")]),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.form
                                                              .deliveryMethod
                                                              .address,
                                                          expression:
                                                            "form.deliveryMethod.address",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form__control",
                                                      attrs: {
                                                        id: "address",
                                                        name: "address",
                                                        placeholder:
                                                          _vm.get_translation_constant(
                                                            "text_enter_address_latin_letters"
                                                          ),
                                                        type: "text",
                                                      },
                                                      domProps: {
                                                        value:
                                                          _vm.form
                                                            .deliveryMethod
                                                            .address,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.$set(
                                                            _vm.form
                                                              .deliveryMethod,
                                                            "address",
                                                            $event.target.value
                                                          )
                                                        },
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _vm.hasErrorMessage(
                                                      "deliveryMethod.address"
                                                    )
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "form__error",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                        " +
                                                                _vm._s(
                                                                  _vm.get_translation_constant(
                                                                    "text_field_is_required"
                                                                  )
                                                                ) +
                                                                "\n                                                    "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "col-12 col-lg-6",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "form__col",
                                                    class:
                                                      _vm.hasError("agent"),
                                                  },
                                                  [
                                                    _c("label", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.get_translation_constant(
                                                            "text_choose_agent"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("multiselect", {
                                                      staticClass:
                                                        "form-control",
                                                      attrs: {
                                                        multiple: false,
                                                        placeholder:
                                                          _vm.get_translation_constant(
                                                            "text_choose_agent"
                                                          ),
                                                        options: _vm.agentList,
                                                        label: "name",
                                                        selectLabel: "",
                                                        deselectLabel: "",
                                                        optionHeight: 48,
                                                        showPointer: true,
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "singleLabel",
                                                            fn: function (ref) {
                                                              var option =
                                                                ref.option
                                                              return [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "multiselect__single",
                                                                    class:
                                                                      typeof option.id !==
                                                                        "undefined" &&
                                                                      option.id ===
                                                                        ""
                                                                        ? "multiselect__placeholder__active"
                                                                        : "",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        typeof option.id !==
                                                                          "undefined" &&
                                                                          option.id ===
                                                                            ""
                                                                          ? _vm.get_translation_constant(
                                                                              "text_delivery_through_agent"
                                                                            )
                                                                          : option.name
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                      model: {
                                                        value:
                                                          _vm.form
                                                            .deliveryMethod
                                                            .agent,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form
                                                              .deliveryMethod,
                                                            "agent",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.deliveryMethod.agent",
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _vm.hasErrorMessage("agent")
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "form__error",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                        " +
                                                                _vm._s(
                                                                  _vm.get_translation_constant(
                                                                    "text_field_is_required"
                                                                  )
                                                                ) +
                                                                "\n                                                    "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "col-12 col-lg-6",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "form__col",
                                                    class:
                                                      _vm.hasError(
                                                        "phone_prefix"
                                                      ) ||
                                                      _vm.hasError(
                                                        "phone_number"
                                                      ),
                                                  },
                                                  [
                                                    _c("label", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.get_translation_constant(
                                                            "text_phone"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "phone__block",
                                                      },
                                                      [
                                                        _c("multiselect", {
                                                          staticClass:
                                                            "form-control",
                                                          attrs: {
                                                            multiple: false,
                                                            placeholder: "",
                                                            options:
                                                              _vm.locationPrefixes,
                                                            label: "title",
                                                            selectLabel: "",
                                                            deselectLabel: "",
                                                            optionHeight: 48,
                                                            showPointer: true,
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "singleLabel",
                                                                fn: function (
                                                                  props
                                                                ) {
                                                                  return [
                                                                    _c("img", {
                                                                      staticClass:
                                                                        "option__image",
                                                                      attrs: {
                                                                        src: props
                                                                          .option
                                                                          .image,
                                                                        width:
                                                                          "16",
                                                                      },
                                                                    }),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "option__title",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            props
                                                                              .option
                                                                              .title
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                },
                                                              },
                                                              {
                                                                key: "option",
                                                                fn: function (
                                                                  props
                                                                ) {
                                                                  return [
                                                                    _c("img", {
                                                                      staticClass:
                                                                        "option__image",
                                                                      attrs: {
                                                                        src: props
                                                                          .option
                                                                          .image,
                                                                        width:
                                                                          "16",
                                                                      },
                                                                    }),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "option__title",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            props
                                                                              .option
                                                                              .title
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                },
                                                              },
                                                            ],
                                                            null,
                                                            true
                                                          ),
                                                          model: {
                                                            value:
                                                              _vm.form
                                                                .phone_prefix,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.form,
                                                                "phone_prefix",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "form.phone_prefix",
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm.form
                                                                  .phone_number,
                                                              expression:
                                                                "form.phone_number",
                                                            },
                                                          ],
                                                          staticClass:
                                                            "form__control type_tel",
                                                          attrs: {
                                                            type: "tel",
                                                          },
                                                          domProps: {
                                                            value:
                                                              _vm.form
                                                                .phone_number,
                                                          },
                                                          on: {
                                                            input: function (
                                                              $event
                                                            ) {
                                                              if (
                                                                $event.target
                                                                  .composing
                                                              ) {
                                                                return
                                                              }
                                                              _vm.$set(
                                                                _vm.form,
                                                                "phone_number",
                                                                $event.target
                                                                  .value
                                                              )
                                                            },
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _vm.hasErrorMessage(
                                                          "phone_prefix"
                                                        ) ||
                                                        _vm.hasError(
                                                          "phone_number"
                                                        )
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "form__error",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                                                            " +
                                                                    _vm._s(
                                                                      _vm.get_translation_constant(
                                                                        "text_field_is_required"
                                                                      )
                                                                    ) +
                                                                    "\n                                                        "
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  : method.shipping_type_id === 3
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.form.deliveryMethod.id !==
                                                  "undefined" &&
                                                method.id ===
                                                  _vm.form.deliveryMethod.id,
                                              expression:
                                                "(form.deliveryMethod.id !=='undefined') && (method.id === form.deliveryMethod.id)",
                                            },
                                          ],
                                          staticClass:
                                            "delivery__address_block",
                                        },
                                        [
                                          _c("div", { staticClass: "row" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "col-12 col-lg-6",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "form__col",
                                                    class: _vm.hasError(
                                                      "deliveryMethod.first_name"
                                                    ),
                                                  },
                                                  [
                                                    _c("label", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.get_translation_constant(
                                                            "text_your_first_name_ukraine"
                                                          )
                                                        )
                                                      ),
                                                      _c("sup", [_vm._v("*")]),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.form
                                                              .deliveryMethod
                                                              .first_name,
                                                          expression:
                                                            "form.deliveryMethod.first_name",
                                                        },
                                                      ],
                                                      ref: "novaPoshtaAddressFirstName",
                                                      refInFor: true,
                                                      staticClass:
                                                        "form__control",
                                                      attrs: {
                                                        placeholder:
                                                          _vm.get_translation_constant(
                                                            "text_first_name_ukraine"
                                                          ),
                                                        type: "text",
                                                      },
                                                      domProps: {
                                                        value:
                                                          _vm.form
                                                            .deliveryMethod
                                                            .first_name,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.$set(
                                                            _vm.form
                                                              .deliveryMethod,
                                                            "first_name",
                                                            $event.target.value
                                                          )
                                                        },
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _vm.hasErrorMessage(
                                                      "deliveryMethod.first_name"
                                                    )
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "form__error",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                        " +
                                                                _vm._s(
                                                                  _vm.get_translation_constant(
                                                                    "text_field_is_required"
                                                                  )
                                                                ) +
                                                                "\n                                                    "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "col-12 col-lg-6",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "form__col",
                                                    class: _vm.hasError(
                                                      "deliveryMethod.last_name"
                                                    ),
                                                  },
                                                  [
                                                    _c("label", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.get_translation_constant(
                                                            "text_your_last_name_ukraine"
                                                          )
                                                        )
                                                      ),
                                                      _c("sup", [_vm._v("*")]),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.form
                                                              .deliveryMethod
                                                              .last_name,
                                                          expression:
                                                            "form.deliveryMethod.last_name",
                                                        },
                                                      ],
                                                      ref: "novaPoshtaAddressLastName",
                                                      refInFor: true,
                                                      staticClass:
                                                        "form__control",
                                                      attrs: {
                                                        placeholder:
                                                          _vm.get_translation_constant(
                                                            "text_last_name_ukraine"
                                                          ),
                                                        type: "text",
                                                      },
                                                      domProps: {
                                                        value:
                                                          _vm.form
                                                            .deliveryMethod
                                                            .last_name,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.$set(
                                                            _vm.form
                                                              .deliveryMethod,
                                                            "last_name",
                                                            $event.target.value
                                                          )
                                                        },
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _vm.hasErrorMessage(
                                                      "deliveryMethod.last_name"
                                                    )
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "form__error",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                        " +
                                                                _vm._s(
                                                                  _vm.get_translation_constant(
                                                                    "text_field_is_required"
                                                                  )
                                                                ) +
                                                                "\n                                                    "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "col-12 col-lg-6",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "form__col",
                                                    class: _vm.hasError(
                                                      "deliveryMethod.middle_name"
                                                    ),
                                                  },
                                                  [
                                                    _c("label", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.get_translation_constant(
                                                            "text_your_middle_name_ukraine"
                                                          )
                                                        )
                                                      ),
                                                      _c("sup", [_vm._v("*")]),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.form
                                                              .deliveryMethod
                                                              .middle_name,
                                                          expression:
                                                            "form.deliveryMethod.middle_name",
                                                        },
                                                      ],
                                                      ref: "novaPoshtaAddressMiddleName",
                                                      refInFor: true,
                                                      staticClass:
                                                        "form__control",
                                                      attrs: {
                                                        placeholder:
                                                          _vm.get_translation_constant(
                                                            "text_middle_name_ukraine"
                                                          ),
                                                        type: "text",
                                                      },
                                                      domProps: {
                                                        value:
                                                          _vm.form
                                                            .deliveryMethod
                                                            .middle_name,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.$set(
                                                            _vm.form
                                                              .deliveryMethod,
                                                            "middle_name",
                                                            $event.target.value
                                                          )
                                                        },
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _vm.hasErrorMessage(
                                                      "deliveryMethod.middle_name"
                                                    )
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "form__error",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                        " +
                                                                _vm._s(
                                                                  _vm.get_translation_constant(
                                                                    "text_field_is_required"
                                                                  )
                                                                ) +
                                                                "\n                                                    "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "col-12 col-lg-6",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "form__col",
                                                    class: _vm.hasError(
                                                      "deliveryMethod.text_your_city"
                                                    ),
                                                  },
                                                  [
                                                    _c("label", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.get_translation_constant(
                                                            "text_your_city"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("multiselect", {
                                                      staticClass:
                                                        "form-control",
                                                      attrs: {
                                                        multiple: false,
                                                        placeholder:
                                                          _vm.get_translation_constant(
                                                            "text_enter_street_in_ukraine_letters"
                                                          ),
                                                        options:
                                                          _vm.form
                                                            .deliveryMethod
                                                            .novaPoshta.cities,
                                                        label: "Description",
                                                        selectLabel: "",
                                                        deselectLabel: "",
                                                        optionHeight: 48,
                                                        showPointer: true,
                                                      },
                                                      on: {
                                                        "search-change":
                                                          _vm.asyncCities,
                                                        select:
                                                          _vm.loadStreetsOrWarehouses,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form
                                                            .deliveryMethod
                                                            .novaPoshta.city,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form
                                                              .deliveryMethod
                                                              .novaPoshta,
                                                            "city",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.deliveryMethod.novaPoshta.city",
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _vm.hasErrorMessage(
                                                      "deliveryMethod.novaPoshta.street"
                                                    )
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "form__error",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                        " +
                                                                _vm._s(
                                                                  _vm.get_translation_constant(
                                                                    "text_field_is_required"
                                                                  )
                                                                ) +
                                                                "\n                                                    "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "col-12 col-lg-6",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "form__col",
                                                    class: _vm.hasError(
                                                      "deliveryMethod.novaPoshta.street"
                                                    ),
                                                  },
                                                  [
                                                    _c("label", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.get_translation_constant(
                                                            "text_delivery_street"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("multiselect", {
                                                      staticClass:
                                                        "form-control",
                                                      attrs: {
                                                        multiple: false,
                                                        placeholder:
                                                          _vm.get_translation_constant(
                                                            "text_enter_street_in_ukraine_letters"
                                                          ),
                                                        options:
                                                          _vm.form
                                                            .deliveryMethod
                                                            .novaPoshta.streets,
                                                        label: "Description",
                                                        selectLabel: "",
                                                        deselectLabel: "",
                                                        optionHeight: 48,
                                                        showPointer: true,
                                                      },
                                                      on: {
                                                        "search-change":
                                                          _vm.searchTimeOut,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form
                                                            .deliveryMethod
                                                            .novaPoshta.street,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form
                                                              .deliveryMethod
                                                              .novaPoshta,
                                                            "street",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.deliveryMethod.novaPoshta.street",
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _vm.hasErrorMessage(
                                                      "deliveryMethod.novaPoshta.street"
                                                    )
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "form__error",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                        " +
                                                                _vm._s(
                                                                  _vm.get_translation_constant(
                                                                    "text_field_is_required"
                                                                  )
                                                                ) +
                                                                "\n                                                    "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "col-12 col-lg-6",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "form__col",
                                                    class: _vm.hasError(
                                                      "deliveryMethod.novaPoshta.house"
                                                    ),
                                                  },
                                                  [
                                                    _c("label", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.get_translation_constant(
                                                            "text_choose_house"
                                                          )
                                                        )
                                                      ),
                                                      _c("sup", [_vm._v("*")]),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.form
                                                              .deliveryMethod
                                                              .novaPoshta.house,
                                                          expression:
                                                            "form.deliveryMethod.novaPoshta.house",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form__control",
                                                      attrs: {
                                                        placeholder:
                                                          _vm.get_translation_constant(
                                                            "text_house"
                                                          ),
                                                        type: "text",
                                                      },
                                                      domProps: {
                                                        value:
                                                          _vm.form
                                                            .deliveryMethod
                                                            .novaPoshta.house,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.$set(
                                                            _vm.form
                                                              .deliveryMethod
                                                              .novaPoshta,
                                                            "house",
                                                            $event.target.value
                                                          )
                                                        },
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _vm.hasErrorMessage(
                                                      "deliveryMethod.novaPoshta.house"
                                                    )
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "form__error",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                        " +
                                                                _vm._s(
                                                                  _vm.get_translation_constant(
                                                                    "text_field_is_required"
                                                                  )
                                                                ) +
                                                                "\n                                                    "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "col-12 col-lg-6",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "form__col",
                                                    class: _vm.hasError(
                                                      "deliveryMethod.novaPoshta.flat"
                                                    ),
                                                  },
                                                  [
                                                    _c("label", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.get_translation_constant(
                                                            "text_choose_house"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.form
                                                              .deliveryMethod
                                                              .novaPoshta.flat,
                                                          expression:
                                                            "form.deliveryMethod.novaPoshta.flat",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form__control",
                                                      attrs: {
                                                        placeholder:
                                                          _vm.get_translation_constant(
                                                            "text_flat"
                                                          ),
                                                        type: "text",
                                                      },
                                                      domProps: {
                                                        value:
                                                          _vm.form
                                                            .deliveryMethod
                                                            .novaPoshta.flat,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.$set(
                                                            _vm.form
                                                              .deliveryMethod
                                                              .novaPoshta,
                                                            "flat",
                                                            $event.target.value
                                                          )
                                                        },
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _vm.hasErrorMessage(
                                                      "deliveryMethod.novaPoshta.flat"
                                                    )
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "form__error",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                        " +
                                                                _vm._s(
                                                                  _vm.get_translation_constant(
                                                                    "text_field_is_required"
                                                                  )
                                                                ) +
                                                                "\n                                                    "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "col-12 col-lg-6",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "form__col",
                                                    class:
                                                      _vm.hasError("agent"),
                                                  },
                                                  [
                                                    _c("label", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.get_translation_constant(
                                                            "text_recipient"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("multiselect", {
                                                      staticClass:
                                                        "form-control",
                                                      attrs: {
                                                        multiple: false,
                                                        placeholder:
                                                          _vm.get_translation_constant(
                                                            "text_choose_agent"
                                                          ),
                                                        options: _vm.agentList,
                                                        label: "name",
                                                        selectLabel: "",
                                                        deselectLabel: "",
                                                        optionHeight: 48,
                                                        showPointer: true,
                                                      },
                                                      on: {
                                                        select: _vm.updateNames,
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "singleLabel",
                                                            fn: function (ref) {
                                                              var option =
                                                                ref.option
                                                              return [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "multiselect__single",
                                                                    class:
                                                                      typeof option.id !==
                                                                        "undefined" &&
                                                                      option.id ===
                                                                        ""
                                                                        ? "multiselect__placeholder__active"
                                                                        : "",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        typeof option.id !==
                                                                          "undefined" &&
                                                                          option.id ===
                                                                            ""
                                                                          ? _vm.get_translation_constant(
                                                                              "text_delivery_through_agent"
                                                                            )
                                                                          : option.name
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                      model: {
                                                        value:
                                                          _vm.form
                                                            .deliveryMethod
                                                            .agent,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form
                                                              .deliveryMethod,
                                                            "agent",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.deliveryMethod.agent",
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _vm.hasErrorMessage("agent")
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "form__error",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                        " +
                                                                _vm._s(
                                                                  _vm.get_translation_constant(
                                                                    "text_field_is_required"
                                                                  )
                                                                ) +
                                                                "\n                                                    "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "col-12 col-lg-6",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "form__col",
                                                    class:
                                                      _vm.hasError(
                                                        "phone_prefix"
                                                      ) ||
                                                      _vm.hasError(
                                                        "phone_number"
                                                      ),
                                                  },
                                                  [
                                                    _c("label", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.get_translation_constant(
                                                            "text_phone"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "phone__block",
                                                      },
                                                      [
                                                        _c("multiselect", {
                                                          staticClass:
                                                            "form-control",
                                                          attrs: {
                                                            multiple: false,
                                                            placeholder: "",
                                                            options:
                                                              _vm.locationPrefixes,
                                                            label: "title",
                                                            selectLabel: "",
                                                            deselectLabel: "",
                                                            optionHeight: 48,
                                                            showPointer: true,
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "singleLabel",
                                                                fn: function (
                                                                  props
                                                                ) {
                                                                  return [
                                                                    _c("img", {
                                                                      staticClass:
                                                                        "option__image",
                                                                      attrs: {
                                                                        src: props
                                                                          .option
                                                                          .image,
                                                                        width:
                                                                          "16",
                                                                      },
                                                                    }),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "option__title",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            props
                                                                              .option
                                                                              .title
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                },
                                                              },
                                                              {
                                                                key: "option",
                                                                fn: function (
                                                                  props
                                                                ) {
                                                                  return [
                                                                    _c("img", {
                                                                      staticClass:
                                                                        "option__image",
                                                                      attrs: {
                                                                        src: props
                                                                          .option
                                                                          .image,
                                                                        width:
                                                                          "16",
                                                                      },
                                                                    }),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "option__title",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            props
                                                                              .option
                                                                              .title
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                },
                                                              },
                                                            ],
                                                            null,
                                                            true
                                                          ),
                                                          model: {
                                                            value:
                                                              _vm.form
                                                                .phone_prefix,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.form,
                                                                "phone_prefix",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "form.phone_prefix",
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm.form
                                                                  .phone_number,
                                                              expression:
                                                                "form.phone_number",
                                                            },
                                                          ],
                                                          staticClass:
                                                            "form__control type_tel",
                                                          attrs: {
                                                            type: "tel",
                                                          },
                                                          domProps: {
                                                            value:
                                                              _vm.form
                                                                .phone_number,
                                                          },
                                                          on: {
                                                            input: function (
                                                              $event
                                                            ) {
                                                              if (
                                                                $event.target
                                                                  .composing
                                                              ) {
                                                                return
                                                              }
                                                              _vm.$set(
                                                                _vm.form,
                                                                "phone_number",
                                                                $event.target
                                                                  .value
                                                              )
                                                            },
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _vm.hasErrorMessage(
                                                          "phone_prefix"
                                                        ) ||
                                                        _vm.hasError(
                                                          "phone_number"
                                                        )
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "form__error",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                                                            " +
                                                                    _vm._s(
                                                                      _vm.get_translation_constant(
                                                                        "text_field_is_required"
                                                                      )
                                                                    ) +
                                                                    "\n                                                        "
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  : method.shipping_type_id === 4
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.form.deliveryMethod.id !==
                                                  "undefined" &&
                                                method.id ===
                                                  _vm.form.deliveryMethod.id,
                                              expression:
                                                "(form.deliveryMethod.id !=='undefined') && (method.id === form.deliveryMethod.id)",
                                            },
                                          ],
                                          staticClass:
                                            "delivery__address_block",
                                        },
                                        [
                                          _c("div", { staticClass: "row" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "col-12 col-lg-6",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "form__col",
                                                    class: _vm.hasError(
                                                      "deliveryMethod.first_name"
                                                    ),
                                                  },
                                                  [
                                                    _c("label", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.get_translation_constant(
                                                            "text_your_first_name_ukraine"
                                                          )
                                                        )
                                                      ),
                                                      _c("sup", [_vm._v("*")]),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.form
                                                              .deliveryMethod
                                                              .first_name,
                                                          expression:
                                                            "form.deliveryMethod.first_name",
                                                        },
                                                      ],
                                                      ref: "novaPoshtaAddressFirstName",
                                                      refInFor: true,
                                                      staticClass:
                                                        "form__control",
                                                      attrs: {
                                                        placeholder:
                                                          _vm.get_translation_constant(
                                                            "text_first_name_ukraine"
                                                          ),
                                                        type: "text",
                                                      },
                                                      domProps: {
                                                        value:
                                                          _vm.form
                                                            .deliveryMethod
                                                            .first_name,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.$set(
                                                            _vm.form
                                                              .deliveryMethod,
                                                            "first_name",
                                                            $event.target.value
                                                          )
                                                        },
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _vm.hasErrorMessage(
                                                      "deliveryMethod.first_name"
                                                    )
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "form__error",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                        " +
                                                                _vm._s(
                                                                  _vm.get_translation_constant(
                                                                    "text_field_is_required"
                                                                  )
                                                                ) +
                                                                "\n                                                    "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "col-12 col-lg-6",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "form__col",
                                                    class: _vm.hasError(
                                                      "deliveryMethod.last_name"
                                                    ),
                                                  },
                                                  [
                                                    _c("label", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.get_translation_constant(
                                                            "text_your_last_name_ukraine"
                                                          )
                                                        )
                                                      ),
                                                      _c("sup", [_vm._v("*")]),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.form
                                                              .deliveryMethod
                                                              .last_name,
                                                          expression:
                                                            "form.deliveryMethod.last_name",
                                                        },
                                                      ],
                                                      ref: "novaPoshtaAddressLastName",
                                                      refInFor: true,
                                                      staticClass:
                                                        "form__control",
                                                      attrs: {
                                                        placeholder:
                                                          _vm.get_translation_constant(
                                                            "text_last_name_ukraine"
                                                          ),
                                                        type: "text",
                                                      },
                                                      domProps: {
                                                        value:
                                                          _vm.form
                                                            .deliveryMethod
                                                            .last_name,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.$set(
                                                            _vm.form
                                                              .deliveryMethod,
                                                            "last_name",
                                                            $event.target.value
                                                          )
                                                        },
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _vm.hasErrorMessage(
                                                      "deliveryMethod.last_name"
                                                    )
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "form__error",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                        " +
                                                                _vm._s(
                                                                  _vm.get_translation_constant(
                                                                    "text_field_is_required"
                                                                  )
                                                                ) +
                                                                "\n                                                    "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "col-12 col-lg-6",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "form__col",
                                                    class: _vm.hasError(
                                                      "deliveryMethod.middle_name"
                                                    ),
                                                  },
                                                  [
                                                    _c("label", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.get_translation_constant(
                                                            "text_your_middle_name_ukraine"
                                                          )
                                                        )
                                                      ),
                                                      _c("sup", [_vm._v("*")]),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.form
                                                              .deliveryMethod
                                                              .middle_name,
                                                          expression:
                                                            "form.deliveryMethod.middle_name",
                                                        },
                                                      ],
                                                      ref: "novaPoshtaAddressMiddleName",
                                                      refInFor: true,
                                                      staticClass:
                                                        "form__control",
                                                      attrs: {
                                                        placeholder:
                                                          _vm.get_translation_constant(
                                                            "text_middle_name_ukraine"
                                                          ),
                                                        type: "text",
                                                      },
                                                      domProps: {
                                                        value:
                                                          _vm.form
                                                            .deliveryMethod
                                                            .middle_name,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.$set(
                                                            _vm.form
                                                              .deliveryMethod,
                                                            "middle_name",
                                                            $event.target.value
                                                          )
                                                        },
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _vm.hasErrorMessage(
                                                      "deliveryMethod.middle_name"
                                                    )
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "form__error",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                        " +
                                                                _vm._s(
                                                                  _vm.get_translation_constant(
                                                                    "text_field_is_required"
                                                                  )
                                                                ) +
                                                                "\n                                                    "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "col-12 col-lg-6",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "form__col",
                                                    class: _vm.hasError(
                                                      "deliveryMethod.text_your_city"
                                                    ),
                                                  },
                                                  [
                                                    _c("label", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.get_translation_constant(
                                                            "text_your_city"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("multiselect", {
                                                      staticClass:
                                                        "form-control",
                                                      attrs: {
                                                        multiple: false,
                                                        placeholder:
                                                          _vm.get_translation_constant(
                                                            "text_enter_street_in_ukraine_letters"
                                                          ),
                                                        options:
                                                          _vm.form
                                                            .deliveryMethod
                                                            .novaPoshta.cities,
                                                        label: "Description",
                                                        selectLabel: "",
                                                        deselectLabel: "",
                                                        optionHeight: 48,
                                                        showPointer: true,
                                                      },
                                                      on: {
                                                        "search-change":
                                                          _vm.asyncCities,
                                                        select:
                                                          _vm.loadStreetsOrWarehouses,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form
                                                            .deliveryMethod
                                                            .novaPoshta.city,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form
                                                              .deliveryMethod
                                                              .novaPoshta,
                                                            "city",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.deliveryMethod.novaPoshta.city",
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _vm.hasErrorMessage(
                                                      "deliveryMethod.novaPoshta.street"
                                                    )
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "form__error",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                        " +
                                                                _vm._s(
                                                                  _vm.get_translation_constant(
                                                                    "text_field_is_required"
                                                                  )
                                                                ) +
                                                                "\n                                                    "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "col-12 col-lg-6",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "form__col",
                                                    class: _vm.hasError(
                                                      "deliveryMethod.novaPoshta.warehouse"
                                                    ),
                                                  },
                                                  [
                                                    _c("label", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.get_translation_constant(
                                                            "text_delivery_warehouse"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("multiselect", {
                                                      staticClass:
                                                        "form-control",
                                                      attrs: {
                                                        multiple: false,
                                                        placeholder:
                                                          _vm.get_translation_constant(
                                                            "text_enter_warehouse_in_ukraine_letters"
                                                          ),
                                                        options:
                                                          _vm.warehouseList,
                                                        label: "Description",
                                                        selectLabel: "",
                                                        deselectLabel: "",
                                                        optionHeight: 48,
                                                        showPointer: true,
                                                      },
                                                      on: {
                                                        "search-change":
                                                          _vm.searchTimeOutWarehouse,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form
                                                            .deliveryMethod
                                                            .novaPoshta
                                                            .warehouse,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form
                                                              .deliveryMethod
                                                              .novaPoshta,
                                                            "warehouse",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.deliveryMethod.novaPoshta.warehouse",
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _vm.hasErrorMessage(
                                                      "deliveryMethod.novaPoshta.warehouse"
                                                    )
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "form__error",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                        " +
                                                                _vm._s(
                                                                  _vm.get_translation_constant(
                                                                    "text_field_is_required"
                                                                  )
                                                                ) +
                                                                "\n                                                    "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "col-12 col-lg-6",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "form__col",
                                                    class:
                                                      _vm.hasError("agent"),
                                                  },
                                                  [
                                                    _c("label", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.get_translation_constant(
                                                            "text_recipient"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("multiselect", {
                                                      staticClass:
                                                        "form-control",
                                                      attrs: {
                                                        multiple: false,
                                                        placeholder:
                                                          _vm.get_translation_constant(
                                                            "text_choose_agent"
                                                          ),
                                                        options: _vm.agentList,
                                                        label: "name",
                                                        selectLabel: "",
                                                        deselectLabel: "",
                                                        optionHeight: 48,
                                                        showPointer: true,
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "singleLabel",
                                                            fn: function (ref) {
                                                              var option =
                                                                ref.option
                                                              return [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "multiselect__single",
                                                                    class:
                                                                      typeof option.id !==
                                                                        "undefined" &&
                                                                      option.id ===
                                                                        ""
                                                                        ? "multiselect__placeholder__active"
                                                                        : "",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        typeof option.id !==
                                                                          "undefined" &&
                                                                          option.id ===
                                                                            ""
                                                                          ? _vm.get_translation_constant(
                                                                              "text_delivery_through_agent"
                                                                            )
                                                                          : option.name
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                      model: {
                                                        value:
                                                          _vm.form
                                                            .deliveryMethod
                                                            .agent,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form
                                                              .deliveryMethod,
                                                            "agent",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.deliveryMethod.agent",
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _vm.hasErrorMessage("agent")
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "form__error",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                        " +
                                                                _vm._s(
                                                                  _vm.get_translation_constant(
                                                                    "text_field_is_required"
                                                                  )
                                                                ) +
                                                                "\n                                                    "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "col-12 col-lg-6",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "form__col",
                                                    class:
                                                      _vm.hasError(
                                                        "phone_prefix"
                                                      ) ||
                                                      _vm.hasError(
                                                        "phone_number"
                                                      ),
                                                  },
                                                  [
                                                    _c("label", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.get_translation_constant(
                                                            "text_phone"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "phone__block",
                                                      },
                                                      [
                                                        _c("multiselect", {
                                                          staticClass:
                                                            "form-control",
                                                          attrs: {
                                                            multiple: false,
                                                            placeholder: "",
                                                            options:
                                                              _vm.locationPrefixes,
                                                            label: "title",
                                                            selectLabel: "",
                                                            deselectLabel: "",
                                                            optionHeight: 48,
                                                            showPointer: true,
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "singleLabel",
                                                                fn: function (
                                                                  props
                                                                ) {
                                                                  return [
                                                                    _c("img", {
                                                                      staticClass:
                                                                        "option__image",
                                                                      attrs: {
                                                                        src: props
                                                                          .option
                                                                          .image,
                                                                        width:
                                                                          "16",
                                                                      },
                                                                    }),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "option__title",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            props
                                                                              .option
                                                                              .title
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                },
                                                              },
                                                              {
                                                                key: "option",
                                                                fn: function (
                                                                  props
                                                                ) {
                                                                  return [
                                                                    _c("img", {
                                                                      staticClass:
                                                                        "option__image",
                                                                      attrs: {
                                                                        src: props
                                                                          .option
                                                                          .image,
                                                                        width:
                                                                          "16",
                                                                      },
                                                                    }),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "option__title",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            props
                                                                              .option
                                                                              .title
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                },
                                                              },
                                                            ],
                                                            null,
                                                            true
                                                          ),
                                                          model: {
                                                            value:
                                                              _vm.form
                                                                .phone_prefix,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.form,
                                                                "phone_prefix",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "form.phone_prefix",
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm.form
                                                                  .phone_number,
                                                              expression:
                                                                "form.phone_number",
                                                            },
                                                          ],
                                                          staticClass:
                                                            "form__control type_tel",
                                                          attrs: {
                                                            type: "tel",
                                                          },
                                                          domProps: {
                                                            value:
                                                              _vm.form
                                                                .phone_number,
                                                          },
                                                          on: {
                                                            input: function (
                                                              $event
                                                            ) {
                                                              if (
                                                                $event.target
                                                                  .composing
                                                              ) {
                                                                return
                                                              }
                                                              _vm.$set(
                                                                _vm.form,
                                                                "phone_number",
                                                                $event.target
                                                                  .value
                                                              )
                                                            },
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _vm.hasErrorMessage(
                                                          "phone_prefix"
                                                        ) ||
                                                        _vm.hasError(
                                                          "phone_number"
                                                        )
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "form__error",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                                                            " +
                                                                    _vm._s(
                                                                      _vm.get_translation_constant(
                                                                        "text_field_is_required"
                                                                      )
                                                                    ) +
                                                                    "\n                                                        "
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                              ]
                            : _vm.account.location_id === 2
                            ? [
                                method.shipping_type_id === 1
                                  ? void 0
                                  : method.shipping_type_id === 2
                                  ? void 0
                                  : _vm._e(),
                              ]
                            : _vm.account.location_id === 3
                            ? [
                                method.shipping_type_id === 1
                                  ? void 0
                                  : method.shipping_type_id === 2
                                  ? void 0
                                  : _vm._e(),
                              ]
                            : _vm.account.location_id === 4
                            ? [
                                method.shipping_type_id === 1
                                  ? void 0
                                  : method.shipping_type_id === 2
                                  ? void 0
                                  : _vm._e(),
                              ]
                            : _vm._e(),
                        ]
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form__col form__col_collapse" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "collapsed",
                              attrs: {
                                "data-bs-toggle": "collapse",
                                href: "#collapseComment",
                                role: "button",
                                "aria-expanded": "true",
                                "aria-controls": "collapseComment",
                              },
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.get_translation_constant(
                                      "text_comments"
                                    )
                                  )
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "collapse show",
                              attrs: { id: "collapseComment" },
                            },
                            [
                              _c("div", { staticClass: "card card-body" }, [
                                _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.deliveryMethod.comment,
                                      expression: "form.deliveryMethod.comment",
                                    },
                                  ],
                                  staticClass: "form__control",
                                  attrs: {
                                    rows: "3",
                                    type: "text",
                                    placeholder:
                                      _vm.get_translation_constant(
                                        "text_comment"
                                      ) + "...",
                                  },
                                  domProps: {
                                    value: _vm.form.deliveryMethod.comment,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.form.deliveryMethod,
                                        "comment",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "form__col",
                          style: _vm.hasError("shippingMethodCostError"),
                        },
                        [
                          _vm.hasErrorMessage("shippingMethodCostError")
                            ? _c("div", { staticClass: "form__error" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.get_translation_constant(
                                        "text_insufficient_funds"
                                      )
                                    ) +
                                    "\n                            "
                                ),
                              ])
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "d-md-flex justify-content-end mb-4" },
                        [
                          _c("input", {
                            staticClass:
                              "btn btn__large btn__green delivery__success d-block",
                            attrs: {
                              type: "submit",
                              disabled: !_vm.deliveryValidated,
                            },
                            domProps: {
                              value: _vm.get_translation_constant(
                                "text_arrange_delivery"
                              ),
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.submitDelivery.apply(null, arguments)
                              },
                            },
                          }),
                        ]
                      ),
                    ],
                    2
                  ),
                ]),
              ]),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c("alert-modal", {
        attrs: {
          modalId: _vm.modalId,
          title: _vm.modalTitle,
          type: _vm.modalType,
          message: _vm.modalMessage,
          promos: _vm.promos,
          translations: _vm.translations,
          lng: _vm.lng,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tfoot", [_c("tr")])
  },
]
render._withStripped = true

export { render, staticRenderFns }